import {instance} from ".";

export const getQuizStates = () => {
  return instance({
    method: "get",
    url: "/work/api/dict/quiz-states"
  });
};

export const getQuizCard = id => {
  return instance({
    method: "get",
    url: `/work/api/quiz/${id}/card`
  });
};

export const getQuizMainInfo = id => {
  return instance({
    method: "get",
    url: `/work/api/quiz/${id}`
  });
};

export const createQuiz = data => {
  return instance({
    method: "post",
    url: `/work/api/quiz`,
    data
  });
};

export const updateQuizMain = (id, data) => {
  return instance({
    method: "put",
    url: `/work/api/quiz/${id}`,
    data
  });
};

export const deleteQuiz = id => {
  return instance({
    method: "delete",
    url: `/work/api/quiz/${id}`
  });
};

export const getQuestionTemplateDict = () => {
  return instance({
    method: "get",
    url: "/work/api/dict/20"
  });
};

export const getQuestionList = (id) => {
  return instance({
    method: "get",
    url: `/work/api/quiz/${id}/questions`
  })
}

export const createQuestion = (id, data) => {
  return instance({
    method: "post",
    url: `/work/api/quiz/${id}/question`,
    data
  });
}

export const updateQuestion = (id, main) => {
  const data = {
    main: main
  }
  return instance({
    method: "put",
    url: `/work/api/quiz/question/${id}`,
    data
  });
};

export const deleteQuestion = id => {
  return instance({
    method: "delete",
    url: `/work/api/quiz/question/${id}`
  });
};

export const getQuestionVariantList = (id) => {
  return instance({
    method: "get",
    url: `/work/api/quiz/question/${id}/variant`
  })
}

export const createQuestionVariant = (id, data) => {
  return instance({
    method: "post",
    url: `/work/api/quiz/question/${id}/variant`,
    data
  });
}

export const deleteQuestionVariant = id => {
  return instance({
    method: "delete",
    url: `/work/api/quiz/question/variant/${id}`
  });
};

export const updateQuestionVariant = (id, main) => {
  const data = {
    main: main
  }
  return instance({
    method: "put",
    url: `/work/api/quiz/question/variant/${id}`,
    data
  });
}

export const updateQuestionScale = (id, main) => {
  const data = {
    main: main
  }
  return instance({
    method: "put",
    url: `/work/api/quiz/question/${id}/scale`,
    data
  })
}

export const deleteLogo = (id) => {
  return instance({
    method: "delete",
    url: `/work/api/quiz/${id}/logo`,
  });
};

export const updateLogo = (id, file) => {
  const data = new FormData();
  data.set('file', file);

  return instance({
    method: "post",
    url: `/work/api/quiz/${id}/logo`,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data
  });
};

export const getQuestionStatistic = (id) => {
  return instance({
    method: "get",
    url: `/work/api/quiz/question/${id}/statistic`
  })
}

export const getQuizStatistic = (id) => {
  return instance({
    method: "get",
    url: `/work/api/quiz/${id}/statistic`
  })
}

export default {
  getQuizStates,
  getQuizCard,
  getQuizMainInfo,
  createQuiz,
  deleteQuiz,
  updateQuizMain,
  getQuestionTemplateDict,
  getQuestionList,
  createQuestion,
  updateQuestion,
  deleteQuestion,
  getQuestionVariantList,
  createQuestionVariant,
  updateQuestionVariant,
  deleteQuestionVariant,
  updateQuestionScale,
  deleteLogo,
  updateLogo,
  getQuestionStatistic,
  getQuizStatistic
};
